import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { ValuesGrid } from "../Common/ValuesGrid";
/**
 * Displays selected values as help text or markdown
 * @param props
 * @returns
 */
export function InfoValues(props) {
    var _a, _b;
    const attribute = useCsAttribute();
    const values = (_b = (_a = attribute.values) === null || _a === void 0 ? void 0 : _a.filter((value) => value.isSelected)) !== null && _b !== void 0 ? _b : [];
    return (_jsx(ValuesGrid, { defaultEnabled: true, values: values, ValueDisplayComponent: Fragment, children: props.children }));
}
//# sourceMappingURL=InfoValues.js.map